import React from "react";
import Select from "react-select";
import Field from "./Field";
import "./SearchableSelectField.css";

// Searchable dropdown built on react-select, styled to match the native
// inputs in this folder (TextField, SelectField) via `unstyled` +
// `classNamePrefix` rather than react-select's default theme - see
// SearchableSelectField.css's .rma-nc-rs__* rules.
//
// Also used by the case detail page (TicketNew/detail/FormBits.js), which is
// why any other react-select prop (inputId, onInputChange, menuPosition…) is
// passed straight through.
export default function SearchableSelectField({
  label,
  value,
  options,
  onChange,
  placeholder = "Search…",
  isLoading,
  isDisabled,
  isClearable = true,
  required,
  className,
  wrapperClassName,
  ...selectProps
}) {
  const selected =
    options.find(function (option) {
      return option.value === value;
    }) ?? null;

  const control = (
    <Select
      {...selectProps}
      value={selected}
      onChange={function (option) {
        onChange(option?.value ?? "");
      }}
      options={options}
      isLoading={isLoading}
      isDisabled={isDisabled}
      isClearable={isClearable}
      placeholder={placeholder}
      noOptionsMessage={function () {
        return "No matches found";
      }}
      unstyled
      classNamePrefix="rma-nc-rs"
      className={className}
    />
  );

  if (!label) return control;

  return (
    <Field label={label} required={required} className={wrapperClassName}>
      {control}
    </Field>
  );
}
